<template>
  <ion-page>
    <ion-header>
      <HeaderWithBackButtonComponent title="パスワードリセット" :show-button="false" />
    </ion-header>
    <ion-content>
      <p class="ion-text-center">
        ご登録されたメールアドレスを入力し、「次へ」<br>
        ボタンを押してください。<br>
        ✳︎ご登録メールアドレス宛にパスワード更新のURL<br>
        が送信されますのでパスワードの再設定をお願いします。
      </p>

      <div class="ion-margin-horizontal">
        <p class="input-label">メールアドレス</p>
        <ion-item fill="outline" class="containers" style="margin-bottom: 5px" :class="{ 'border-danger': (errors && errors.email) }">
          <ion-input class="mail-addless-input" v-model="email" placeholder="メールアドレス"></ion-input>
        </ion-item>
        <ion-text color="danger" v-if="errors && errors.email">{{ errors.email }}</ion-text>
      </div>

      <ion-grid class="ion-margin-end">
        <ion-col>
          <ion-button class="primary-button" style="width: 100%" @click="forgotPassword()" >送信</ion-button>
        </ion-col>
      </ion-grid>

    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonButton,
  IonContent,
  IonInput,
  IonItem,
  IonText,
  loadingController,
  LoadingOptions, IonHeader
} from '@ionic/vue'
import { Device } from '@capacitor/device';
import StorageService from '../../utils/StorageService'
import request from '../../utils/Request'
import { useRouter } from 'vue-router';
import { useForm, useFormErrors, useField } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { ERR_ACCOUNT_IS_LOCKED } from '@/consts/error-message'
import HeaderWithBackButtonComponent from "@/components/HeaderWithBackButton.vue";

const router = useRouter()

const schema = yup.object({
  'email': yup.string()
      .required('メールアドレスをご入力ください')
      .email('メールアドレスが正しくありません'),
})

const formLogin = useForm({
  validationSchema: schema
})

const { value: email } = useField<string>("email")

const errors = useFormErrors() as any;

const isShowAccountLockModal = ref<boolean>(false)

async function forgotPassword() {
  const resp = await formLogin.validate();

  if (resp.valid) {
    const deviceInfo = await Device.getInfo()
    const data = {...formLogin.values, ...{
        app_id: import.meta.env.VITE_APP_ID,
        device_uuid: await StorageService.get('deviceUuid'),
        osVersion: deviceInfo.osVersion,
        os: deviceInfo.operatingSystem
      }}

    const loading = await createLoading('送信処理中...')
    await loading.present()
    request.post('/forgot-password', data).then((res) => {
      if (res.status) {
        router.push({
          name: 'WebWithdrawalCodeVerify',
          query: {
            email: formLogin.values.email,
            type: 'forgot'
          }
        })
      }
    }).catch((err) => {
      if (err.response?.status == 422) {
        console.log(err.response.data.message)
        if (err.response.data.message === ERR_ACCOUNT_IS_LOCKED) {
          isShowAccountLockModal.value = true;
        } else {
          formLogin.setErrors(err.response.data.errors);
        }
      }
      // formLogin.setErrors({email: ['エラーが発生しました']})
    }).finally(() => {
      loading.dismiss()
    })
  }
}
async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
    message: msg,
    duration: duration,
    spinner: spinner,
  })
}

</script>